<template>
  <v-container flat fluid>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="title">Roles</span>
      </v-card-title>

      <v-form>
        <v-container flat fluid>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field label="Attribute" value="Roles" outlined filled hide-details readonly></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <list-string :items="obj.roles"></list-string>
            </v-col>
          </v-row>
          <v-row>
            <v-chip
              v-for="(role, index) in obj.roles"
              class="ma-2"
              :key="index"
              close
              @click:close="removeRole(index)"
            >{{ role }}</v-chip>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import listString from "@/components/listString";

export default {
  props: {
    obj: Object,
    template: Boolean
  },
  components: {
    listString
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    removeRole(index) {
      this.obj.roles.splice(index, 1);
    }
  },
  mounted() {}
};
</script>
